import { Contract, ethers } from "ethers";
import CheerUpJSON from "../abis/CheerUp.json";
import CheerUpBlindBoxJSON from "../abis/CheerUpBlindBox.json";
import cheersUpPeriodStakeJSON from "../abis/cheersUpPeriodStake.json";
import cheersUpBadgeJSON from "../abis/cheersUpBadge.json";
import cheersUpEmojiMergeJSON from "../abis/cheersUpEmojiMerge.json";
import {
  CHEER_UP_ADDRESS,
  CHEER_UP_BADGE_ADDRESS,
  CHEER_UP_BLIND_BOX_ADDRESS,
  CHEER_UP_PERIOD_STAKE_ADDRESS,
  CHEER_UP_EMOJI_MERGE_ADDRESS,
} from "../constants";

export const getCheerUpContract = (providerOrSigner): Contract | undefined => {
  if (!providerOrSigner) {
    return;
  }
  console.log("CHEER_UP_ADDRESS", CHEER_UP_ADDRESS);
  return new ethers.Contract(CHEER_UP_ADDRESS, CheerUpJSON, providerOrSigner);
};

export const getCheerUpBlindBoxContract = (
  providerOrSigner
): Contract | undefined => {
  if (!providerOrSigner) {
    return;
  }
  console.log("CHEER_UP_BLIND_BOX_ADDRESS", CHEER_UP_BLIND_BOX_ADDRESS);
  return new ethers.Contract(
    CHEER_UP_BLIND_BOX_ADDRESS,
    CheerUpBlindBoxJSON,
    providerOrSigner
  );
};

export const getCheerUpPeriodStakeContract = (
  providerOrSigner
): Contract | undefined => {
  if (!providerOrSigner) {
    return;
  }
  console.log("CHEER_UP_PERIOD_STAKE_ADDRESS", CHEER_UP_PERIOD_STAKE_ADDRESS);
  return new ethers.Contract(
    CHEER_UP_PERIOD_STAKE_ADDRESS,
    cheersUpPeriodStakeJSON,
    providerOrSigner
  );
};

export const getCheerUpInterface = () => {
  return new ethers.utils.Interface(CheerUpJSON);
};

export const getCheerUpBadgeContract = (
  providerOrSigner
): Contract | undefined => {
  if (!providerOrSigner) {
    return;
  }
  console.log("CHEER_UP_BADGE_ADDRESS", CHEER_UP_BADGE_ADDRESS);
  return new ethers.Contract(
    CHEER_UP_BADGE_ADDRESS,
    cheersUpBadgeJSON,
    providerOrSigner
  );
};

export const getCheerUpEmojiMergeContract = (
  providerOrSigner
): Contract | undefined => {
  if (!providerOrSigner) {
    return;
  }
  console.log("CHEER_UP_EMOJI_MERGE_ADDRESS", CHEER_UP_EMOJI_MERGE_ADDRESS);
  return new ethers.Contract(
    CHEER_UP_EMOJI_MERGE_ADDRESS,
    cheersUpEmojiMergeJSON,
    providerOrSigner
  );
};

export const getCommonEmojiMergeContract = ({
  contractAddress,
  abi,
  providerOrSigner,
}): Contract | undefined => {
  return new ethers.Contract(contractAddress, abi, providerOrSigner);
};
